import React, { CSSProperties, FC, ReactElement, ReactNode } from "react";
import { FlexCol, FlexRow } from "../../ui-kit/Layout/Flex";
import { Typography } from "../../ui-kit/Typography";
import styles from "./SummaryTable.module.css";
import classNames from "classnames";
import { Glyph, Icon } from "ui-kit";
import Colors from "ui-kit/colors";

type SummaryItemProps = {
  title: string;
  value: ReactNode;
  icon?: Glyph;
  highlightValue?: boolean;
  description?: string;
};

export const SummaryItem: FC<SummaryItemProps> = ({
  icon,
  title,
  value,
  highlightValue,
  description,
}) => {
  return (
    <FlexCol>
      <FlexRow
        justifyContent="space-between"
        alignItems="center"
        className={styles.row}
      >
        <Typography variant="body3" color="grey500" className={styles.title}>
          {icon ? (
            <Icon
              size="S"
              name={icon}
              color={Colors["grey500"]}
              className={styles.icon}
            />
          ) : null}
          {title}
        </Typography>
        <Typography
          variant="body3"
          color={highlightValue ? "green300" : "black"}
          align="right"
        >
          {highlightValue ? <strong>{value}</strong> : value}
        </Typography>
      </FlexRow>
      {description ? (
        <FlexRow>
          <Typography variant="body4" className={styles.description}>
            {description}
          </Typography>
        </FlexRow>
      ) : null}
    </FlexCol>
  );
};

type SummaryTableProps = {
  children: ReactElement[] | ReactElement | ReactNode;
  style?: CSSProperties;
  className?: string;
};

export const SummaryBlock = ({
  title,
  children,
}: {
  title?: string;
  children: ReactElement[] | ReactElement | ReactNode;
}) => {
  return (
    <div className={styles.block}>
      {title ? (
        <Typography variant="body3" className={styles.blockTitle}>
          <strong>{title}</strong>
        </Typography>
      ) : null}
      {children}
    </div>
  );
};

export const SummaryTable = ({
  children,
  style,
  className,
}: SummaryTableProps) => {
  return (
    <div className={classNames(styles.container, className)} style={style}>
      <div className={styles.summary}>{children}</div>
    </div>
  );
};
